import * as React from "react";
import { createValidator } from "not-valid";

import { useTimeHasAlreadyPassed } from "../customHooks";

export const useTimeHasAlreadyPassedValidator = () => {
    const validator = React.useMemo(() => createValidator(useTimeHasAlreadyPassed, "Must be in the past"), []);
    return validator;
};
